import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { activeDeactiveRoleAPI, addRoleAPI, deleteRoleAPI, getAllPagesAPI, getAllRolesAPI, getTableColumnNames, updatePagePermissionAPI, updateRoleAPI } from "../../helpers/fakebackend_helper";
import { toast } from "react-toastify";
import { t } from "i18next";



// Fetch Logs Table Column Names
export const fetchRoleTableColumnNames = createAsyncThunk(
  "roles/fetchTableColumnNames",
  async (role, thunkAPI) => {
    try {
      const response = await getTableColumnNames(role); 
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error || "Something went wrong");
    }
  }
);

// Thunk to fetch all roles
export const fetchAllRoles = createAsyncThunk(
  "roles/fetchAll",
  async (logs, thunkAPI) => {
    try {
      const response = await getAllRolesAPI(logs); 
      
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error || "Something went wrong");
    }
  }
);

// Add Role data
export const createRole = createAsyncThunk("roles/add", async (role, thunkAPI) => {  
  try {
    const response = await addRoleAPI(role);
    toast.success(t(response.message));
    return response;
  } catch (error) {
    return thunkAPI.rejectWithValue(error || "Something went wrong");
  }
});

// Update Role data
export const updateRoles = createAsyncThunk("roles/update", async (role, thunkAPI) => {
  
  try {
    const response = await updateRoleAPI(role);
    toast.success(t(response.message));
    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error || "Something went wrong");
  }
});

// Delete Role data
export const deleteRole = createAsyncThunk("roles/delete", async (role, thunkAPI) => {
  try {
    const response = await deleteRoleAPI(role);
    toast.success(t(response.message));
    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error || "Something went wrong");
  }
});

// Active deactive Role 
export const activateDeactivateRoles = createAsyncThunk("roles/active", async (role, thunkAPI) => {
  try {
    const response = await activeDeactiveRoleAPI(role);
    toast.success(t(response.message));
    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error || "Something went wrong");
  }
});

// Get Page Table column 
export const fetchPageTableColumnNames = createAsyncThunk(
  "permission/fetchPermissionTableColumnNames",
  async (page, thunkAPI) => {
    try {
      const response = await getTableColumnNames(page); 
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error || "Something went wrong");
    }
  }
);

// Get Page Permission Data
export const fetchAllPages = createAsyncThunk(
  "permission/fetchAllPages",
  async (page, thunkAPI) => {
    try {
      const response = await getAllPagesAPI(page); 
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error || "Something went wrong");
    }
  }
);

//Update Page Permission

export const updatePagePermission = createAsyncThunk("page/updatePagePermission", async (page, thunkAPI) => {
  
  try {
    const response = await updatePagePermissionAPI(page);
    toast.success(t(response.message));
    return response.data;
  } catch (error) {    
    toast.error(error.message);
    return thunkAPI.rejectWithValue(error || "Something went wrong");
  }
});